export default __webpack_public_path__ + "static/media/logo.fdea9497.svg";